import { render, staticRenderFns } from "./sponsors.vue?vue&type=template&id=0ae36884&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"
import style0 from "./sponsors.vue?vue&type=style&index=0&id=0ae36884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae36884",
  null
  
)

export default component.exports